import { GetFinancingRequestDetails } from "../../network/request.network";
import { REQUEST_DETAILS} from "./order.type";

export const getRequestDetails= order => ({
    type : REQUEST_DETAILS,
    payload : order
})


export const GetRequestDetailsAction = orderId => {
    return(dispatch,getState)=>{
        GetFinancingRequestDetails(orderId,(res)=>{
    dispatch(getRequestDetails(res.data.model));
  },()=>{})
}
}